module.exports = __webpack_public_path__ + "img/infj.2f0c0910.png";